import { parse, isValid }  from 'date-fns';
import { enGB } from 'date-fns/locale';

export class DateConverter {

  private static readonly formatStringDateFns: string = "yyyy-MM-dd HH:mm:ss.SSSSSSSXXX";

  // Returns whether a string represents a date in the format or not used by CustomJsonResult, in C# "yyyy-MM-dd HH:mm:ss.fffffffK"
  private static isDate = (s: string) => isValid(parse(s, this.formatStringDateFns, new Date(), { locale: enGB }));
    
  // Parse an object and convert any string objects in the format or not used by CustomJsonResult to date objects
  static stringsToDates<T>(obj: T): T {
    if (obj) {
      Object.keys(obj)
        .filter((key: keyof {}) => obj[key] && typeof obj[key] === 'string' && DateConverter.isDate(obj[key]))
        .map((key: keyof {}) => { obj[key] = parse(obj[key], this.formatStringDateFns, new Date(), { locale: enGB }) });

      Object.keys(obj)
        .filter((key: keyof {}) => obj[key] && typeof obj[key] === 'object')
        .map((key: keyof {}) => { obj[key] = DateConverter.stringsToDates(obj[key]) });
    }

    return obj;
  }
}
